import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bcc4ea6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "status" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = {
  key: 0,
  class: "card-body"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title d-flex flex-row align-items-center justify-content-between" }, "Modus", -1))
const _hoisted_5 = {
  class: "btn-group ms-3",
  role: "group",
  "aria-label": "First group"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye fa-fw" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " view", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil fa-fw" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " design", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen-ruler fa-fw" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " advanced", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title d-flex flex-row align-items-center justify-content-between" }, "Status", -1))
const _hoisted_16 = {
  class: "btn-group ms-3",
  role: "group",
  "aria-label": "First group"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-stop fa-fw" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " inactive", -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-play fa-fw" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " active", -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Do you want to save the flow before activating it? ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.ready)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(['btn', 'btn-outline-secondary', _ctx.vm.readonly ? 'active' : '']),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.vm.readonly = true))
              }, _hoisted_8, 2),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(['btn', 'btn-outline-secondary', !_ctx.vm.readonly && !_ctx.vm.advanced ? 'active' : '']),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.vm.advanced = _ctx.vm.readonly = false))
              }, _hoisted_11, 2),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(['btn', 'btn-outline-secondary', !_ctx.vm.readonly && _ctx.vm.advanced ? 'active' : '']),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.vm.advanced = (_ctx.vm.readonly = false) || true))
              }, _hoisted_14, 2)
            ]),
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(['btn', 'btn-outline-secondary', !_ctx.vm.flow.active ? 'active' : '']),
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.deactivate && _ctx.deactivate(...args)))
              }, _hoisted_19, 2),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(['btn', _ctx.vm.flow.active ? 'btn-outline-success' : 'btn-outline-secondary', _ctx.vm.flow.active ? 'active' : '']),
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.activate && _ctx.activate(...args)))
              }, _hoisted_22, 2)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.confirmSave)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 0,
          onConfirm: _ctx.saveAndActivate,
          onCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirmSave = false)),
          title: "Save flow",
          "show-footer": true
        }, {
          default: _withCtx(() => [
            _hoisted_23
          ]),
          _: 1
        }, 8, ["onConfirm"]))
      : _createCommentVNode("", true)
  ]))
}